import { NavLink, useLocation } from "react-router-dom";
import "./style.css";
// import logo from "../../images/icons/logo.png";
import dashboard from "../../images/icons/dashboard.png";
import sales from "../../images/icons/sales.png";
import purchases from "../../images/icons/purchases.png";
import settings from "../../images/icons/settings.png";
import userPic from "../../images/icons/user_pic.png";
import { useEffect, useState } from "react";
import { capitalize, isStockTransferOnly } from "../../utils";
import { confirmAlert } from "react-confirm-alert";
import config from "../../config";
import Modal from "react-bootstrap/Modal";
import $ from "jquery";
import "./style.css";
import ThemeColorModal from "../ThemeColorModal/ThemeColorModal";
import { resetThemeBtnColor } from "../../themeManager";
import {
  FiGrid,
  FiDatabase,
  FiShoppingCart,
  FiTruck,
  FiSliders,
  FiCreditCard,
  FiRefreshCw,
  FiBarChart2,
  FiSettings,
  FiLogOut,
  FiGitBranch,
  FiArchive,
  FiTag,
  FiDollarSign,
  FiMaximize2,
  FiPackage,
  FiBriefcase,
  FiUser,
  FiUsers,
  FiCornerUpLeft,
  FiRotateCcw,
  FiFileText,
  FiLayers,
  FiActivity,
  FiTrendingUp,
  FiShoppingBag,
  FiPieChart,
  FiClock,
} from "react-icons/fi";

function getMainSectionIcon(key) {
  switch (key) {
    case "dashboard":
      return <FiGrid className="sidebar-icon" />;
    case "masters":
      return <FiDatabase className="sidebar-icon" />;
    case "purchases":
      return <FiShoppingCart className="sidebar-icon" />;
    case "challan":
      return <FiTruck className="sidebar-icon" />;
    case "stock":
      return <FiSliders className="sidebar-icon" />;
    case "expense":
      return <FiCreditCard className="sidebar-icon" />;
    case "syncLog":
      return <FiRefreshCw className="sidebar-icon" />;
    case "report":
      return <FiBarChart2 className="sidebar-icon" />;
    case "setting":
      return <FiSettings className="sidebar-icon" />;
    case "logout":
      return <FiLogOut className="sidebar-icon" />;
    default:
      return <FiGrid className="sidebar-icon" />;
  }
}

const subIconMap = {
  // Masters
  Branch: FiGitBranch,
  Godown: FiArchive,
  "Item Category": FiTag,
  "Expense Category": FiDollarSign,
  UOM: FiMaximize2,
  Item: FiPackage,
  Company: FiBriefcase,
  User: FiUser,
  Supplier: FiTruck,
  Customer: FiUsers,

  // Purchases
  Purchase: FiShoppingCart,
  "Purchase Return": FiRotateCcw,

  // Challan
  Challan: FiFileText,
  "Challan Return": FiCornerUpLeft,

  // Reports
  "Stock Summary": FiLayers,
  "Stock Movement": FiActivity,
  "Cash Summary": FiDollarSign,
  "Cash Movement": FiTrendingUp,
  "Itemized Sales": FiShoppingBag,
  "Itemized Purchase": FiPackage,
  Sales: FiPieChart,
  "Sales Retrun": FiCornerUpLeft,
  "Sales Return": FiCornerUpLeft,
  Purchases: FiShoppingCart,
  "Purchases Return": FiRotateCcw,
  "Non Moving Item": FiClock,
};

function getSubSectionIcon(label, fallbackIcon) {
  const IconComp = subIconMap[label];
  if (IconComp) {
    return <IconComp className="sidebar-sub-icon" />;
  }
  if (fallbackIcon && typeof fallbackIcon === "string") {
    return <img src={fallbackIcon} className="img-fluid pe-2" alt="" />;
  }
  return <FiFileText className="sidebar-sub-icon" />;
}

function Sidebar(props) {
  const [showColorModal, setShowColorModal] = useState(false);
  const [user, setUser] = useState(() => {
    try {
      const inv = localStorage.getItem("inventory");
      return inv ? JSON.parse(inv).userData || {} : {};
    } catch (e) {
      return {};
    }
  });
  const [comp, setComp] = useState(() => {
    try {
      const inv = localStorage.getItem("inventory");
      return inv ? JSON.parse(inv).userData?.comp_data || {} : {};
    } catch (e) {
      return {};
    }
  });
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  const [reportList, setReportList] = useState([]);
  const [expiryInfo, setExpiryInfo] = useState({ text: "", className: "" });
  console.log("expiryInfoexpiryInfo", user?.user_id);

  useEffect(function () {
    try {
      const inv = localStorage.getItem("inventory");
      if (inv) {
        setUser(JSON.parse(inv).userData || {});
        setComp(JSON.parse(inv).userData?.comp_data || {});
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  function changeStatus() {
    confirmAlert({
      title: "Are you sure?",
      message: "You want to logout.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            if (localStorage.getItem("inventory")) {
              localStorage.removeItem("inventory");
            }
            resetThemeBtnColor();
            window.location.href = config.baseUrl;
          },
        },
        {
          label: "No",
        },
      ],
    });
  }

  const report = [
    {
      label: "Stock Summary",
      href: "/stock/list",
      icon: sales,
      isVisible: [2, 3, 4, 7, 8, 9],
      showList: [2, 3, 4, 7, 8, 9],
    },
    {
      label: "Stock Movement",
      href: "/stock/movement",
      icon: sales,
      isVisible: [2, 3, 4, 7, 8, 9],
      showList: [2, 3, 4, 7, 8, 9],
    },
    {
      label: "Cash Summary",
      href: "/payment/list",
      icon: sales,
      isVisible: [2, 3, 4, 7, 9],
      showList: [2, 3, 4, 7, 9],
    },
    {
      label: "Cash Movement",
      href: "/payment/movement",
      icon: sales,
      isVisible: [2, 3, 4, 7, 9],
      showList: [2, 3, 4, 7, 9],
    },
    {
      label: "Itemized Sales",
      href: "/sale/item-movement",
      icon: sales,
      isVisible: [2, 3, 4, 7, 8],
      showList: [2, 3, 4, 7, 8],
    },
    {
      label: "Itemized Purchase",
      href: "/itemized-purchase",
      icon: sales,
      isVisible: [2, 3, 4, 7, 8],
      showList: [2, 3, 4, 7, 8],
    },
    {
      label: "Sales",
      href: "/sale/movement",
      icon: sales,
      isVisible: [2, 3, 4, 7, 8],
      showList: [2, 3, 4, 7, 8],
    },
    {
      label: "Sales Retrun",
      href: "/sale-return/movement",
      icon: sales,
      isVisible: [2, 3, 4],
      showList: [2, 3, 4],
    },
    {
      label: "Purchases",
      href: "/purchase-movement",
      icon: sales,
      isVisible: [2, 3, 4, 7, 8],
      showList: [2, 3, 4, 7, 8],
    },
    {
      label: "Purchases Return",
      href: "/purchase-return-movement",
      icon: sales,
      isVisible: [2, 3, 4],
      showList: [2, 3, 4],
    },
    {
      label: "Non Moving Item",
      href: "/Item/Non-Moving-Item",
      icon: sales,
      isVisible: [2, 3, 4, 7],
      showList: [2, 3, 4, 7],
    },
  ];
  const links = {
    dashboard: {
      label: "Dashboard",
      href: "/dashboard",
      icon: dashboard,
      isVisible: [1, 2, 3, 4, 7, 8, 9],
    },
    masters: [
      {
        label: "Branch",
        href: "/branch",
        icon: settings,
        isVisible: [2],
        showList: [1, 2, 3, 4, 5],
      },
      {
        label: "Godown",
        href: "/godown",
        icon: settings,
        isVisible: [2, 3, 4],
        showList: [1, 2, 3, 4, 5],
      },
      {
        label: "Item Category",
        href: "/item-category",
        icon: settings,
        isVisible: [2],
        showList: [1, 2, 5],
      },
      {
        label: "Expense Category",
        href: "/category/expense",
        icon: settings,
        isVisible: [2],
        showList: [1, 2, 5],
      },
      {
        label: "UOM",
        href: "/uom",
        icon: settings,
        isVisible: [2, 3],
        showList: [1, 2, 3, 4, 5],
      },
      {
        label: "Item",
        href: "/item",
        icon: settings,
        isVisible: [2, 3, 4],
        showList: [1, 2, 3, 4, 5],
      },
      {
        label: "Company",
        href: "/company",
        icon: settings,
        isVisible: [1],
        showList: [1, 2, 3, 4, 5],
      },

      {
        label: "User",
        href: "/user",
        icon: settings,
        isVisible: [1, 2],
        showList: [1, 2, 3, 4, 5],
      },
      {
        label: "Supplier",
        href: "/buyer",
        icon: settings,
        isVisible: [2, 3],
        showList: [1, 2, 3, 4, 5],
      },
      {
        label: "Customer",
        href: "/customer",
        icon: settings,
        isVisible: [2, 3],
        showList: [1, 2, 3, 4, 5],
      },
    ],
    purchases: [
      {
        label: "Purchase",
        href: "/purchase",
        icon: purchases,
        isVisible: [2, 3, 4, 8],
        showList: [2, 3, 4, 8],
      },
      {
        label: "Purchase Return",
        href: "/purchase-return",
        icon: settings,
        isVisible: [2, 3, 4],
        showList: [2, 3, 4],
      },
    ],
    challan: [
      {
        label: "Challan",
        href: "/challan",
        icon: sales,
        isVisible: [2, 3, 4, 7, 8, 9],
        showList: [2, 3, 4, 7, 8, 9],
      },
      {
        label: "Challan Return",
        href: "/challanRtn",
        icon: sales,
        isVisible: [2, 3, 4],
        showList: [2, 3, 4],
      },
    ],

    stock: {
      label: isStockTransferOnly(user) ? "Stock Transfer" : "Stock Adjustment",
      href: "/stock-adjustment", 
      icon: settings,
      isVisible: [2, 3, 4, 8],
      showList: [2, 3, 4, 8],
    },
    expense: {
      label: "Expense",
      href: "/expense",
      icon: settings,
      isVisible: [2, 3, 4, 7, 9],
      showList: [2, 3, 4, 7, 9],
    },
   
    ...( (Array.isArray(comp) ? comp[0]?.mpos_integration : comp?.mpos_integration) == 1 &&
    [2,3].includes(Number(user?.role_id))
      ? {
          syncLog: {
            label: "Sync Log",
            href: "/sync-log",
            icon: settings,
            isVisible: [1, 2, 3, 4, 5, 7, 8, 9],
          },
        }
      : {}),
    report: report.filter(
      (item) =>
        !(
          [93, 178, "93", "178"].includes(user?.user_id) &&
          (item.href === "/payment/list" || item.href === "/payment/movement")
        )
    ),
    logout: {
      label: "Logout",
      href: "/logout",
      icon: settings,
      isVisible: [1, 2, 3, 4, 5, 7, 8, 9],
    },
  };

  const path = {
    masters: links.masters.map((v) => v.href),
    purchases: links.purchases.map((v) => v.href),
    challan: links.challan.map((v) => v.href),
    report: links.report.map((v) => v.href),
  };

  function getExpiryInfo(expiryDateStr) {
    // ❌ expiry date nahi hai → kuch bhi mat dikhao
    if (!expiryDateStr) return null;

    const expiryDate = new Date(expiryDateStr);
    if (Number.isNaN(expiryDate.getTime())) return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    expiryDate.setHours(0, 0, 0, 0);

    const diffMs = expiryDate - today;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    // ❌ 30 din se zyada hai → kuch nahi dikhana
    if (diffDays > 30) return null;

    // Date format DD-MM-YY
    const dd = String(expiryDate.getDate()).padStart(2, "0");
    const mm = String(expiryDate.getMonth() + 1).padStart(2, "0");
    const yy = String(expiryDate.getFullYear()).slice(-2);
    const formatted = `${dd}-${mm}-${yy}`;

    // 🔴 Expired
    if (diffDays < 0) {
      return {
        text: `Expired: ${formatted}`,
        className: "expiry-box expiry-expired",
      };
    }

    // 🔴 Critical (0–2 days)
    if (diffDays <= 2) {
      return {
        text: `Expires: ${formatted}`,
        className: "expiry-box expiry-critical",
      };
    }

    // 🟠 Warning (3–15 days)
    if (diffDays <= 15) {
      const progress = (15 - diffDays) / 15;

      let style;
      if (progress < 0.25) {
        style = { backgroundColor: "#fff2cc", borderColor: "#ffeb99" };
      } else if (progress < 0.5) {
        style = { backgroundColor: "#ffcc66", borderColor: "#ffaa33" };
      } else if (progress < 0.75) {
        style = { backgroundColor: "#ff9966", borderColor: "#ff7733" };
      } else {
        style = { backgroundColor: "#ff6666", borderColor: "#ff4444" };
      }

      return {
        text: `Expires: ${formatted}`,
        className: "expiry-box expiry-warning",
        style,
      };
    }

    // 🟢 Normal (16–30 days)
    return {
      text: `Expires: ${formatted}`,
      className: "expiry-box expiry-normal",
    };
  }

  useEffect(() => {
    console.log("comp.expiry_date", comp);
    if (comp) {
      setExpiryInfo(getExpiryInfo(comp[0]?.expiry_date));
    }
  }, [comp]);
  return (
    <>
      <nav className="sidebar m-1 p-2" id="sidebar">
        <ul className="nav nav-pills flex-column flex-row">
          <li className="py-3 d-flex align-items-center">
            <img
              src={userPic}
              className="img-fluid me-2"
              alt=""
              role="button"
              style={{ width: "38px", height: "38px", flexShrink: 0 }}
            />
            <div className="flex-grow-1" style={{ minWidth: 0 }}>
              <div className="d-flex align-items-center justify-content-between">
                <p className="text-light fw-lighter mb-1" style={{ fontSize: "12px", lineHeight: "14px" }}>Account</p>
                <span
                  role="button"
                  onClick={() => setShowColorModal(true)}
                  title="Theme Settings"
                  style={{ cursor: "pointer", opacity: 0.85, padding: "2px" }}
                >
                  <FiSettings size={15} className="text-light" style={{ verticalAlign: "middle" }} />
                </span>
              </div>
              <p className="text-light fw-bolder mb-0 text-truncate" style={{ fontSize: "13px", lineHeight: "16px" }}>
                Hi, {user?.user_name || "Guest"}
              </p>
            </div>
          </li>

          {expiryInfo && (
            <div className={expiryInfo.className} style={expiryInfo.style}>
              {expiryInfo.text}
            </div>
          )}
          <hr className="mt-0" />
          {Object.keys(links).map((ov, oi) => {
            return (
              <>
                {Array.isArray(links[ov]) ? (
                  <>
                    {links[ov].some((item) =>
                      item.isVisible?.includes(user?.role_id),
                    ) && (
                        <>
                          <li className={`nav-item my-1`}>
                            <a
                              className="flex-fill nav-link rounded-0 py-2 text-light"
                              data-bs-toggle="collapse"
                              href={`#collapse_${ov}`}
                              role="button"
                            >
                              {getMainSectionIcon(ov)}
                              {capitalize(ov)}
                            </a>
                          </li>
                        </>
                      )}
                    <ul
                      className={`collapse list-unstyled ${path[ov].includes(pathname) ||
                        path[ov].includes("/" + pathname.split("/")[1])
                        ? "show"
                        : ""
                        }`}
                      id={`collapse_${ov}`}
                    >
                      {links[ov].map((iv, ii) => {
                        if (iv.isVisible.includes(user?.role_id)) {
                          return (
                            <>
                              <li className="nav-item ms-3">
                                <NavLink
                                  to={iv.href}
                                  className="flex-fill nav-link rounded-0 py-2 text-light"
                                >
                                  {getSubSectionIcon(iv.label, iv.icon)}
                                  {iv.label}
                                </NavLink>
                              </li>
                            </>
                          );
                        } else {
                        }
                      })}
                    </ul>
                  </>
                ) : (
                  <>
                    {ov === "logout" && (
                      <li className="nav-item my-1">
                        <a
                          href="#setting"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowColorModal(true);
                          }}
                          className="flex-fill nav-link rounded-0 py-2 text-light"
                          style={{ cursor: "pointer" }}
                        >
                          <FiSettings className="sidebar-icon" />
                          Setting
                        </a>
                      </li>
                    )}
                    {(links[ov]?.isVisible?.includes(user?.role_id) ||
                      links[ov]?.isVisible?.includes(Number(user?.role_id)) ||
                      ov === "logout") && (
                      <li className="nav-item my-1">
                        {ov === "logout" ? (
                          <a
                            href="#logout"
                            onClick={(e) => {
                              e.preventDefault();
                              setShow(!show);
                            }}
                            className="flex-fill nav-link rounded-0 py-2 text-light"
                            style={{ cursor: "pointer" }}
                          >
                            {getMainSectionIcon(ov)}
                            {links[ov].label}
                          </a>
                        ) : (
                          <NavLink
                            to={links[ov].href}
                            className="flex-fill nav-link rounded-0 py-2 text-light"
                          >
                            {getMainSectionIcon(ov)}
                            {links[ov].label}
                          </NavLink>
                        )}
                      </li>
                    )}
                  </>
                )}
              </>
            );
          })}
        </ul>
      </nav>

      <Modal
        show={show}
        onHide={() => setShow(!show)}
        keyboard={false}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <h4
            style={{ marginLeft: "5rem", height: "4px", textAlign: "center" }}
            id="modalhead"
          >
            Are you sure you want to log Out ?
          </h4>
        </Modal.Header>
        <div style={{ textAlign: "center", padding: "30px" }}>
          <button
            style={{
              marginRight: "22px",
              borderRadius: "8px",
              fontsize: "14px",
            }}
            onClick={() => setShow(!show)}
            type="button"
            className="btn btn-secondary"
            data-mdb-dismiss="modal"
          >
            CANCEL
          </button>
          <button
            id="sidebar-logout-confirm-btn"
            style={{
              backgroundColor: "var(--theme-btn-color, #4263eb)",
              borderColor: "var(--theme-btn-color, #4263eb)",
              borderRadius: "8px",
            }}
            onClick={() => {
              if (localStorage.getItem("inventory")) {
                localStorage.removeItem("inventory");
                localStorage.removeItem("expiryAlert30DaysSeen");
              }
              resetThemeBtnColor();
              window.location.href = config.baseUrl;
            }}
            type="button"
            className="btn btn-primary"
            data-dynamic-theme="true"
          >
            LOGOUT
          </button>
        </div>
      </Modal>

      <ThemeColorModal
        show={showColorModal}
        onHide={() => setShowColorModal(false)}
      />
    </>
  );
}

export default Sidebar;
